<template>
  <ul class="nav nav-tabs nav-justified">
    <li class="nav-item">
      <inertia-link :class="tab == 'debits' ? 'nav-link active' : 'nav-link'" :href="route('transactions', 'debits')">Debits</inertia-link>
    </li>
    <li class="nav-item">
      <inertia-link :class="tab == 'credits' ? 'nav-link active' : 'nav-link'" :href="route('transactions', 'credits')">Credits</inertia-link>
    </li>
    <li class="nav-item" v-if="!is_linked">
      <inertia-link :class="tab == 'payouts' ? 'nav-link active' : 'nav-link'" :href="route('transactions', 'payouts')">Payout History</inertia-link>
    </li>
    <li class="nav-item">
      <inertia-link :class="tab == 'cash' ? 'nav-link active' : 'nav-link'" :href="route('transactions', 'cash')">Cash/Checks</inertia-link>
    </li>
    <li class="nav-item" v-if="!is_linked">
      <inertia-link :class="tab == 'payment' ? 'nav-link active' : 'nav-link'" :href="route('transactions', 'payment')">Payments</inertia-link>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      tab: {
        type: String,
        default: false
      },
      has_linked: {
        type: Boolean,
        default: false
      },
      is_linked: {
        type: Boolean,
        default: false
      }
    }
  }
</script>